<template>
  <div>
    <members-table :view="view" :row-click-enabled="false"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import membersTable from './table'

export default {
  components: {
    membersTable
  },
  computed: {
    ...mapState('members', {
      view: '_archivedView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/members/archived.vue